module.exports = settings;


//////////////////
// WEBPACK FOOTER
// external "settings"
// module id = Ll2K
// module chunks = 1